
/**
 * @ngdoc directive
 * @name testimonialslideshow
 *
 * @description
 * Slideshow of testimonial
 */
module.directive('testimonialslideshow', ['$timeout', '$document', '$window', 'lodash', function ($timeout, $document, $window, lodash) {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            content: '='
        },
        link: function ($scope, element) {
            var getSliderWidth = function () {
                var position = element[0].querySelector('.aqua-testimonialslideshow--slides').getBoundingClientRect();
                return position.width;
            };
            $scope.containerwidth = '0';
            $scope.safedisplay = false;

            $scope.current = 0;

            $scope.setSlide = function (idx) {
                $scope.current = idx;
            };
            $scope.prev = function () {
                $scope.current = Math.max(0, $scope.current - 1);
            };
            $scope.next = function () {
                $scope.current = Math.min($scope.content.field_contents.length - 1, $scope.current + 1);
            };

            var clearSliderWidth = function () {
                $scope.containerwidth = getSliderWidth();
            };
            var initSliderWidth = function () {
                $scope.containerwidth = getSliderWidth();
                $scope.safedisplay = true;

                // reestimate when resized
                $window.onresize = lodash.throttle(clearSliderWidth, 1000);
            };
            var timer = $timeout(function () {
                // let browser rendering time
                initSliderWidth();
            }, 500);

            // prevent memory leaks
            $scope.$on('$destroy', function () {
                $window.onresize = null;
                $timeout.cancel(timer);
            });
        },
        template:
                '<div class="aqua-testimonialslideshow" ng-style="{\'background-color\': content.field_theme_testimonialslideshow.color_background, \'color\': content.field_theme_testimonialslideshow.color_text}">' +
                '  <a ng-attr-name="{{content.nid}}"></a>' +
                // '  <div class="grid-main">' +

                '    <div class="aqua-testimonialslideshow--slides" ng-swipe-left="next()" ng-swipe-right="prev()" ng-mouseenter="onEnter()" ng-mouseleave="onLeave()">' +
                /* slideshow */
                '      <div ng-if="safedisplay" class="aqua-testimonialslideshow--slider grid" ng-style="{transform:\'translateX(\' + (-current * containerwidth) + \'px)\', \'width\': (containerwidth * content.field_contents.length) + \'px\'}">' +

                '        <div ng-repeat="testimonial in content.field_contents" class="aqua-testimonialslideshow--slide aqua-richtext" ng-bind-html="testimonial | trustAsHtml" ng-style="{\'width\': containerwidth + \'px\'}"></div>' +

                '      </div>' +
                /* slideshow navigation */
                '      <ol class="aqua-testimonialslideshow--dots grid grid-center grid-middle" ng-show="content.field_contents.length > 1">' +
                '        <li ng-click="setSlide($index)" class="aqua-testimonialslideshow--dot" ng-repeat="slide in content.field_contents track by $index" ng-class="{\'is-current\': current === $index}" ng-style="{\'color\': content.field_theme_testimonialslideshow.color_text}"></li>' +
                '      </ol> ' +
                '    </div>' +

                // '  </div>' +
                '</div>'
    };
}]);